"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectVariableReferences = exports.detectVariableReferencesOfEL = exports.matchVariableReferences = void 0;
const varRef_1 = require("../../node/el/controls/varRef");
const controls_1 = require("../../node/el/controls");
const error_1 = require("../../parser/cst/error");
const sentenceEnv_1 = require("../../node/container/sentenceEnv");
const common_1 = require("../common");
const matchVariableReferences = (textEL, sentenceEnv, declarations) => {
    const errors = [];
    const found = [];
    const textRange = sentenceEnv.textRageOfEL(textEL) ?? [0, 0];
    {
        let ramainingText = textEL.text();
        for (const declaration of declarations.values()) {
            if (declaration.attr.name.length === 0)
                continue;
            for (;;) {
                const nameOffset = ramainingText.indexOf(declaration.attr.name);
                if (nameOffset < 0)
                    break;
                const foundTextRange = {
                    start: textRange[0] + nameOffset,
                    end: textRange[0] + nameOffset + declaration.attr.name.length,
                };
                if (declaration.scope.some(scopeRange => (((scopeRange.start.sentenceIndex < sentenceEnv.index)
                    || ((scopeRange.start.sentenceIndex === sentenceEnv.index)
                        && (scopeRange.start.textOffset <= foundTextRange.start)))
                    && ((sentenceEnv.index < scopeRange.end.sentenceIndex)
                        || ((sentenceEnv.index === scopeRange.end.sentenceIndex)
                            && (foundTextRange.end <= scopeRange.end.textOffset)))))) {
                    found.push([[nameOffset, nameOffset + declaration.attr.name.length], declaration]);
                    ramainingText = ramainingText.slice(0, nameOffset) + "　".repeat(declaration.attr.name.length) + ramainingText.slice(nameOffset + declaration.attr.name.length);
                }
            }
        }
    }
    if (found.length === 0)
        return null;
    found.sort(([a], [b]) => ((a[0] - b[0]) || (a[1] - b[1])));
    const text = textEL.text();
    const newItems = [];
    const varRefs = [];
    let lastOffset = 0;
    for (const [offsetRange, declaration] of found) {
        const name = declaration.attr.name;
        if (lastOffset < offsetRange[0]) {
            newItems.push(new controls_1.__Text(text.substring(lastOffset, offsetRange[0]), textEL.range && [textEL.range[0] + lastOffset, textEL.range[0] + offsetRange[0]]));
        }
        const refSentenceTextRange = {
            start: {
                sentenceIndex: sentenceEnv.index,
                textOffset: (textRange?.[0] ?? Number.NaN) + offsetRange[0],
            },
            end: {
                sentenceIndex: sentenceEnv.index,
                textOffset: (textRange?.[0] ?? Number.NaN) + offsetRange[1],
            },
        };
        const range = (textEL.range) ? [
            textEL.range[0] + offsetRange[0],
            textEL.range[0] + offsetRange[1],
        ] : null;
        const varRef = new varRef_1.____VarRef({
            refName: name,
            declarationID: declaration.attr.declarationID,
            refSentenceTextRange,
            range,
        });
        newItems.push(varRef);
        varRefs.push(varRef);
        lastOffset = offsetRange[1];
    }
    if (lastOffset < text.length) {
        newItems.push(new controls_1.__Text(text.substring(lastOffset), textEL.range && [
            textEL.range[0] + lastOffset,
            textEL.range[1],
        ]));
    }
    return {
        value: {
            newItems,
            varRefs,
        },
        errors,
    };
};
exports.matchVariableReferences = matchVariableReferences;
const detectVariableReferencesOfEL = (elToBeModified, sentenceEnv, declarations, lawRefByDeclarationID, pointerEnvsStruct) => {
    const varRefs = [];
    const errors = [];
    for (let childIndex = 0; childIndex < elToBeModified.children.length; childIndex++) {
        const child = elToBeModified.children[childIndex];
        if ((0, common_1.isIgnoreAnalysis)(child)) {
            continue;
        }
        else if (typeof child === "string") {
            continue;
        }
        else if (child instanceof controls_1.__Parentheses && child.attr.type === "square") {
            continue;
        }
        else if (child instanceof controls_1.__Text) {
            const textRange = sentenceEnv.textRageOfEL(child);
            if (!textRange) {
                errors.push(new error_1.ErrorMessage("textRange is null", [
                    child?.range?.[0] ?? 0,
                    child?.range?.[1] ?? 0,
                ]));
                continue;
            }
            const filteredDeclarations = declarations.filterByRange({
                start: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: textRange[0],
                },
                end: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: textRange[1],
                },
            }, true);
            {
                const match = (0, exports.matchVariableReferences)(child, sentenceEnv, filteredDeclarations);
                if (match) {
                    varRefs.push(...match.value.varRefs);
                    errors.push(...match.errors);
                    elToBeModified.children.splice(childIndex, 1, ...match.value.newItems);
                    childIndex += match.value.newItems.length - 1;
                    continue;
                }
            }
        }
        else if ((0, sentenceEnv_1.isSentenceText)(child)) {
            continue;
        }
        else {
            const textRange = sentenceEnv.textRageOfEL(child);
            if (!textRange) {
                errors.push(new error_1.ErrorMessage("textRange is null", [
                    child?.range?.[0] ?? 0,
                    child?.range?.[1] ?? 0,
                ]));
                continue;
            }
            const filteredDeclarations = declarations.filterByRange({
                start: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: textRange[0],
                },
                end: {
                    sentenceIndex: sentenceEnv.index,
                    textOffset: textRange[1],
                },
            }, true);
            const newResult = (0, exports.detectVariableReferencesOfEL)(child, sentenceEnv, filteredDeclarations, lawRefByDeclarationID, pointerEnvsStruct);
            varRefs.push(...newResult.value.varRefs);
            errors.push(...newResult.errors);
        }
    }
    return {
        value: {
            varRefs,
        },
        errors,
    };
};
exports.detectVariableReferencesOfEL = detectVariableReferencesOfEL;
const detectVariableReferences = (sentenceEnvsStruct, declarations, lawRefByDeclarationID, pointerEnvsStruct) => {
    const varRefs = [];
    const errors = [];
    for (const sentenceEnv of sentenceEnvsStruct.sentenceEnvs) {
        const result = (0, exports.detectVariableReferencesOfEL)(sentenceEnv.el, sentenceEnv, declarations.filterByRange({
            start: {
                sentenceIndex: sentenceEnv.index,
                textOffset: 0,
            },
            end: {
                sentenceIndex: sentenceEnv.index + 1,
                textOffset: 0,
            },
        }, true), lawRefByDeclarationID, pointerEnvsStruct);
        if (result) {
            for (const varRef of result.value.varRefs) {
                const lawRef = lawRefByDeclarationID.get(varRef.attr.declarationID);
                if (lawRef) {
                    sentenceEnv.addPointerLike({
                        textRange: sentenceEnv.textRageOfEL(varRef),
                        pointerLike: [varRef, lawRef],
                    });
                }
            }
            varRefs.push(...result.value.varRefs);
            errors.push(...result.errors);
        }
    }
    return { value: { varRefs }, errors };
};
exports.detectVariableReferences = detectVariableReferences;
exports.default = exports.detectVariableReferences;
//# sourceMappingURL=index.js.map